var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSignOut(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.14 3.87C3.99088 3.87 3.87 3.99088 3.87 4.14V13.86C3.87 14.0091 3.99088 14.13 4.14 14.13H9.81C10.2574 14.13 10.62 14.4927 10.62 14.94C10.62 15.3874 10.2574 15.75 9.81 15.75H4.14C3.09618 15.75 2.25 14.9038 2.25 13.86V4.14C2.25 3.09618 3.09618 2.25 4.14 2.25H9.81C10.2574 2.25 10.62 2.61265 10.62 3.06C10.62 3.50735 10.2574 3.87 9.81 3.87H4.14ZM6.02996 9.27C6.02996 8.82265 6.39261 8.46 6.83996 8.46L13.7945 8.46L12.4772 7.14276C12.1609 6.82643 12.1609 6.31357 12.4772 5.99724C12.7936 5.68092 13.3064 5.68092 13.6228 5.99724L16.3228 8.69724C16.6391 9.01357 16.6391 9.52643 16.3228 9.84276L13.6228 12.5428C13.3064 12.8591 12.7936 12.8591 12.4772 12.5428C12.1609 12.2264 12.1609 11.7136 12.4772 11.3972L13.7945 10.08L6.83996 10.08C6.39261 10.08 6.02996 9.71735 6.02996 9.27Z",
    fill: "#333966"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSignOut);
export default __webpack_public_path__ + "static/media/sign-out.c1649f1b.svg";
export { ForwardRef as ReactComponent };